import { LineIcon } from "assets/icons/Common";
import { InformationSetting } from "components/settings";
import { WidgetType } from "types/Widget";

import { CanvasScreen } from "./Canvas";
import { FreeHandWritingSettings } from "./FreeHandWritingSettings";

export const FreeHandWritingWidget: WidgetType = {
  name: "HandWriting Lines",
  component: CanvasScreen, // No type conflict here now
  icon: LineIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 300,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.75,
  },
  defaultState: {
    canvas: {
      selectedLine: "pencil",
      lineWeight: 2,
      color: "#000000",
      disableDrag: false,
    },
  },
  defaultSize: {
    aspectRatio: 1.5,
    widthPercentage: 60,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Use the Handwriting tools to to use different styles of handwriting lines as a dashboard background.",
      },
    },
    canvas: {
      defaultValue: {
        selectedLine: "pencil",
        lineWeight: 2,
        color: "#000000",
        disableDrag: false,
      },
      editor: FreeHandWritingSettings,
      info: {
        label: "Line Styles",
      },
    },
  },
  quickActions: {},
};
